enum MutationNames {
    SUPRESS_GLOBAL_ERROR_POPUP = 'SUPRESS_GLOBAL_ERROR_POPUP'
}

export default MutationNames;